var map = {
	"./IRI.png": "9a16",
	"./UAE.png": "87bb",
	"./USA.png": "6b18",
	"./ar.png": "31df",
	"./en.png": "9996",
	"./fa.png": "5abc",
	"./flags.png": "8c96",
	"./flags2x.png": "13d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1c99";